module.exports = __webpack_public_path__ + "static/banner-585bbdd94bb02847843d4bcf6252e66b.jpeg";